import InputHidedDatePicker from "./InputHidedDatePicker";
import {TextField} from "@material-ui/core";
import TodayRoundedIcon from "@mui/icons-material/TodayRounded";
import {format} from "date-fns";

const MuiDatePicker = (props: {
  open: boolean,
  label: string,
  value: Date | undefined,
  onChange: (date: Date | null) => void,
  onOpen: () => void,
}) => {
  return  <div className={'flex w-40'}>
    <InputHidedDatePicker selected={props.value} locale={"ja"}
                          showMonthYearPicker open={props.open}
                          onChange={props.onChange}/>
    <TextField label={props.label}
               InputProps={{
                 endAdornment: <TodayRoundedIcon/>
               }}
               id={"timestamp-cursor"} variant={"outlined"}
               value={props.value ? format(props.value, 'yyyy年MM月') : ""}
               onClick={props.onOpen}/>
  </div>
}

export default MuiDatePicker;